"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestToolReleaseType = exports.DepsType = void 0;
var DepsType;
(function (DepsType) {
    DepsType["LtsNode"] = "lts-node";
    DepsType["ProjectNode"] = "project-node";
    DepsType["Dotnet"] = "dotnet";
    DepsType["FuncCoreTools"] = "func-core-tools";
    DepsType["TestTool"] = "test-tool";
    DepsType["VxTestApp"] = "vx-test-app";
})(DepsType || (exports.DepsType = DepsType = {}));
var TestToolReleaseType;
(function (TestToolReleaseType) {
    TestToolReleaseType["Npm"] = "npm";
    TestToolReleaseType["Binary"] = "binary";
})(TestToolReleaseType || (exports.TestToolReleaseType = TestToolReleaseType = {}));
//# sourceMappingURL=depsChecker.js.map